import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import "kea-thunk";
import { kea } from "kea";
import update from "react/lib/update";
import { Scrollbars } from "react-custom-scrollbars";
import { httpGet, httpPost, httpPut } from "../../../../Util/http";
import { downloadBlob } from "../../../../Util/downloadBlob";
import { addAlert } from "../../../../MsgNotify/msgNotifyActions";
import { semanticColors } from "../../../../Globals/styles";

const propTypes = {};

const defaultProps = {};

const keaRedux = kea({
  actions: () => ({
    fetching: (status) => ({
      status,
    }),
    setProducts: (products) => ({
      products,
    }),
  }),
  reducers: ({ actions }) => ({
    fetching: [
      false,
      PropTypes.bool,
      {
        [actions.fetching]: (state, payload) => {
          return update(state, {
            $set: payload.status,
          });
        },
      },
    ],
    products: [
      [],
      PropTypes.array,
      {
        [actions.setProducts]: (state, payload) => {
          return update(state, {
            $set: payload.products,
          });
        },
      },
    ],
  }),
  thunks: ({ actions, get, fetch, dispatch, getState }) => ({
    getAsync: async (workplaceId) => {
      actions.fetching(true);
      var _url =
        process.env.REACT_APP_webApiEndPoint +
        `api/arbejdsmiljo/${workplaceId}/datasheets`;
      let products = await httpGet(_url)
        .then((resp) => resp.json())
        .catch((e) => {
          dispatch(addAlert("kunne ikke hente materiel for arbejdssted"));
        });
      await actions.setProducts(products);
      actions.fetching(false);
    },
  }),
});

class UsedProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.props.actions.getAsync(this.props.workplaceId);
  }
  renderHeader = () => {
    return (
      <div style={[styles.row, { backgroundColor: "white" }]}>
        <div style={{ ...styles.tableCell, minWidth: 300 }}>Beskrivelse</div>
        <div style={[styles.tableCell, { textAlign: "center" }]}>
          Sikkerheds datablad
        </div>
        <div style={[styles.tableCell, { textAlign: "center" }]}>
          Teknisk datablad
        </div>
        <div style={[styles.tableCell, { textAlign: "center" }]}>
          Kemisk risikovurdering
        </div>
      </div>
    );
  };
  renderSpinner = () => {
    return this.props.fetching ? (
      <div style={styles.spinner}>
        <i className="fa fa-spinner fa-spin fa-2x"></i>
      </div>
    ) : null;
  };
  renderPdfIcon = (url, name, type) => {
    if (url && url !== "none") {
      return (
        <div
          style={{ height: 18, marginTop: -7 }}
          onClick={async () => {
            let notABlob = url;
            let blob = undefined;
            const myRequest = new Request(notABlob);
            await fetch(myRequest)
              .then((response) => response.blob())
              .then((myBlob) => {
                blob = myBlob;
              });
            downloadBlob(blob, name + "." + type + ".pdf");
          }}
          onTouchEnd={() => {
            let node = {
              document: {
                fileUrl: url,
              },
            };
            this.props.show(node);
          }}
        >
          <i
            style={{ fontSize: 18, cursor: "pointer" }}
            aria-hidden="true"
            className="fa fa-file-pdf-o"
          />
          <div style={{ fontSize: 8 }}>Vis</div>
        </div>
      );
    }
  };

  renderProduct = (materiel, index) => {
    let backgroundColor = "#EBEEF0";
    if (index % 2 == 0) backgroundColor = semanticColors.primaryLight;
    return (
      <div key={index}>
        <div style={[styles.row, { backgroundColor: backgroundColor }]}>
          <div style={{ ...styles.tableCell, minWidth: 300 }}>
            {materiel.name}
          </div>
          <div style={[styles.tableCell, { textAlign: "center" }]}>
            {this.renderPdfIcon(materiel.dataSheet, materiel.name, "sikkerhed")}
          </div>
          <div style={[styles.tableCell, { textAlign: "center" }]}>
            {this.renderPdfIcon(
              materiel.technicalDataSheet,
              materiel.name,
              "teknisk"
            )}
          </div>
          <div style={[styles.tableCell, { textAlign: "center" }]}>
            {this.renderPdfIcon(
              materiel.chemDataSheet,
              materiel.name,
              "kemisk"
            )}
          </div>
        </div>
        {materiel.subs && materiel.subs.length > 0 ? (
          <div style={{ paddingLeft: 25, backgroundColor }}>
            <div style={{ fontStyle: "bold" }}>
              {materiel.materielType === "Materiale"
                ? "Batch numre:"
                : "Serienumre:"}
            </div>
            {materiel.subs.map((string) => {
              return <div>{string}</div>;
            })}
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    return (
      <div style={styles.container}>
        {this.renderHeader()}
        {this.renderSpinner()}
        {this.props.products.map((product, index) => {
          return this.renderProduct(product, index);
        })}
      </div>
    );
  }
}

var styles = {
  container: {
    height: "90%",
  },
  spinner: {
    textAlign: "center",
    marginBottom: "10px",
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  tableCell: {
    boxSizing: "border-box",
    flexGrow: 1,
    width: "100%", // Default to full width
    padding: "0.8em 1.2em",
    overflow: "hidden", // Or flex might break
    listStyle: "none",
    alignSelf: "center",
  },
};

UsedProducts.propTypes = propTypes;

UsedProducts.defaultProps = defaultProps;

export default keaRedux(Radium(UsedProducts));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Arbejdsmiljo/UsedProducts/usedProducts.js